export const streamlitApp = `"""An autogenerated example Streamlit app."""

import streamlit as st

st.title("Hello world!")

st.write("I am a Streamlit app, deployed with Numerous")
` as const;
